import FeelingEvasSectionContent from 'parog-web/components/feeling-evas/sliders/component';
import type { EmberChangeset } from 'ember-changeset';
import type { WrFormComponentSignature } from 'ember-wiser/components/form';
import Slider from 'parog-web/components/mici/base-edition-form/slider';
import t from 'ember-intl/helpers/t';

interface Signature {
  Args: {
    form: WrFormComponentSignature<
      EmberChangeset,
      unknown
    >['Blocks']['default'][0];
  };
}

export default class extends FeelingEvasSectionContent<Signature> {
  <template>
    <Slider @form={{@form}} @key='lackOfEnergy'>
      <:header>
        <div>
          <div class='text-black'>{{t
              'mici-form.lackOfEnergy.long'
              htmlSafe=true
            }}</div>
        </div>
      </:header>
      <:lowest>
        Je ne suis pas du tout d'accord (0)
      </:lowest>
      <:highest>
        Je suis tout à fait d'accord (10)
      </:highest>
    </Slider>
  </template>
}
